// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3bDTy","buttons":"Footer_buttons__3NGax"};